// extracted by mini-css-extract-plugin
export default {"expansionButton":"h35n_","expansionIcon":"WhLiC","rotated":"iFkYE"};